import React from 'react';
import { EditorState } from 'draft-js';
import createMentionPlugin from '@workpatterns/draft-js-mention-plugin';

import {
  createEmptySelectionState,
  contentStateWithInsertedText,
  getContentStateWithAppliedEntity,
} from 'Shared/utils/draftJsHelpers';
import AssigneMentionLink from 'Shared/components/AssigneMentionLink/AssigneMentionLink';

const ADD_MENTION_ENTITY_TYPE = 'mention';

export function mentionPluginCreator({ mentionPrefix = '@', mentionTrigger = '@' }) {
  const mentionPlugin = createMentionPlugin({
    mentionComponent: mentionProps => <AssigneMentionLink mentionProps={mentionProps} />,
    mentionPrefix,
    mentionTrigger,
    positionSuggestions: settings => ({
      left: `${settings.decoratorRect.left}px`,
      top: window.innerWidth > 480 ? `${settings.decoratorRect.top - 10}px` : '0px',
      display: 'block',
      position: window.innerWidth > 480 ? 'fixed' : 'absolute',
      transform: 'scale(1) translateY(-100%)',
      transformOrigin: '1em 0% 0px',
      transition: 'all 0.25s cubic-bezier(0.3, 1.2, 0.2, 1)',
      zIndex: '1050',
    }),
    supportWhitespace: true,
  });
  return mentionPlugin;
}

export function addMention({ editorState, mention, isFirst }) {
  const contentState = editorState.getCurrentContent();
  const selectionState = editorState.getSelection();

  const blockKey = selectionState.getFocusKey();
  const blockOffset = selectionState.getFocusOffset();

  const anchor = isFirst ? mention.name : `@${mention.name}`;

  const selectionForAnchor = createEmptySelectionState(blockKey, blockOffset, blockOffset);
  const contenstStateWithAnchor = contentStateWithInsertedText(contentState, selectionForAnchor, anchor);

  const selectionStateForEntity = createEmptySelectionState(
    blockKey,
    isFirst ? blockOffset - 1 : blockOffset,
    blockOffset + anchor.length
  );
  const contentStateWithCreatedEntity = getContentStateWithAppliedEntity(
    contenstStateWithAnchor,
    selectionStateForEntity,
    ADD_MENTION_ENTITY_TYPE,
    { mention },
    'SEGMENTED'
  );

  const selectionForWhiteSpace = createEmptySelectionState(
    blockKey,
    selectionStateForEntity.getEndOffset(),
    selectionStateForEntity.getEndOffset()
  );
  const contenstStateWithWhiteSpace = contentStateWithInsertedText(
    contentStateWithCreatedEntity,
    selectionForWhiteSpace,
    ' '
  );

  const resultSelectionState = createEmptySelectionState(
    blockKey,
    selectionStateForEntity.getEndOffset() + 1,
    selectionStateForEntity.getEndOffset() + 1
  );

  return EditorState.forceSelection(EditorState.push(editorState, contenstStateWithWhiteSpace), resultSelectionState);
}
